
import {  required,usePermissions,SelectInput } from 'react-admin';

// School holidays as MM/DD/YYYY, sorted ascending. Kept in sync with HOLIDAYS in
// lamsawsapi/config.go and LAMSConstants.holidays in the Java API.
export const HOLIDAYS = [
    // 2023-24 school year
    "09/04/2023", "10/09/2023", "10/10/2023", "10/11/2023", "10/12/2023", "10/13/2023",
    "11/10/2023", "11/22/2023", "11/23/2023", "11/24/2023",
    "12/18/2023", "12/19/2023", "12/20/2023", "12/21/2023", "12/22/2023", "12/25/2023",
    "12/26/2023", "12/27/2023", "12/28/2023", "12/29/2023",
    "01/01/2024", "01/15/2024", "02/19/2024",
    "03/11/2024", "03/12/2024", "03/13/2024", "03/14/2024", "03/15/2024", "03/29/2024",
    "04/19/2024", "05/27/2024", "06/19/2024",
    // 2025-26 school year
    "08/01/2025", "09/01/2025",
    "10/13/2025", "10/14/2025", "10/15/2025", "10/16/2025", "10/17/2025",
    "11/11/2025", "11/26/2025", "11/27/2025", "11/28/2025",
    "12/22/2025", "12/23/2025", "12/24/2025", "12/25/2025", "12/26/2025", "12/27/2025",
    "12/28/2025", "12/29/2025", "12/30/2025", "12/31/2025",
    "01/01/2026", "01/02/2026", "01/19/2026", "02/16/2026",
    "03/16/2026", "03/17/2026", "03/18/2026", "03/19/2026", "03/20/2026",
    "04/03/2026", "04/06/2026", "05/25/2026",
    "06/19/2026", "06/29/2026", "06/30/2026",
    // 2026-27 school year
    "09/07/2026",
    "10/12/2026", "10/13/2026", "10/14/2026", "10/15/2026", "10/16/2026",
    "11/11/2026", "11/25/2026", "11/26/2026", "11/27/2026",
    "12/21/2026", "12/22/2026", "12/23/2026", "12/24/2026", "12/25/2026", "12/26/2026",
    "12/27/2026", "12/28/2026", "12/29/2026", "12/30/2026", "12/31/2026",
    "01/01/2027", "01/18/2027", "02/15/2027",
    "03/15/2027", "03/16/2027", "03/17/2027", "03/18/2027", "03/19/2027",
    "03/26/2027", "03/29/2027",
    "05/31/2027", "06/18/2027", "06/28/2027", "06/29/2027", "06/30/2027",
];

// Zero-based, matches Date#getMonth. School is closed for all of July.
export const SCHOOL_CLOSED_MONTH = 6;

const startYear = 2020;
export const validateEnrollmentDate = [required(),checkEDt]


export function getYears() {
    var d = new Date(),
        year = d.getFullYear(),
        years = [];
        if (d.getMonth() == 11) {
            year =  year + 1
        }
        while (year >= startYear) {
            years.push({ id: year, name: year });
            year = year - 1;
        }
    // console.log("Years ", years);
    return years;
}

export function getCurrYr() {
    var d = new Date(),
    year = d.getFullYear();
    return year;
}

export function isAdmin(permissions) {
    if (permissions !== undefined && permissions.role === 'officemgr') {
        return true;
    }
    return false;
}

function convertDateFormat(inputDate) {
    // Split the input date string using "/"
    const dateParts = inputDate.split('-');

    // Rearrange the parts to match "yyyy-mm-dd" format
    const dd = dateParts[2];
    const yyyy = dateParts[0]; 
    const mm = dateParts[1]; 

    // Join the parts using "-"
    const outputDate = `${mm}/${dd}/${yyyy}`;

    return outputDate;
}

const HOLIDAY_SET = new Set(HOLIDAYS);

function toMMDDYYYY(year, month, day) {
    return `${('0' + (month + 1)).slice(-2)}/${('0' + day).slice(-2)}/${year}`;
}

export function isHoliday(mmddyyyy) {
    return HOLIDAY_SET.has(mmddyyyy);
}

function isWeekday(year, month, day) {
    const dayOfWeek = new Date(year, month, day).getDay();
    return dayOfWeek !== 0 && dayOfWeek !== 6;
}

export function daysInMonth(month, year) {
    return new Date(year, month + 1, 0).getDate();
}

// Only counts days already elapsed so the current month is not overstated.
export function getWeekdaysInMonth(month, year, asOf = new Date()) {
    let weekdays = 0;
    for (let day = 1; day <= daysInMonth(month, year); day++) {
        if (new Date(year, month, day).getTime() <= asOf.getTime() && isWeekday(year, month, day)) {
            weekdays++;
        }
    }
    return weekdays;
}

// Weekday holidays elapsed so far in the month. Mirrors getWeekdaysInMonth so the two
// can be subtracted to get school days. July is closed in full, so every weekday counts.
export function getHolidayCount(year, month, asOf = new Date()) {
    if (month === SCHOOL_CLOSED_MONTH) {
        return getWeekdaysInMonth(month, year, asOf);
    }
    let holidays = 0;
    for (let day = 1; day <= daysInMonth(month, year); day++) {
        if (new Date(year, month, day).getTime() <= asOf.getTime()
            && isWeekday(year, month, day)
            && isHoliday(toMMDDYYYY(year, month, day))) {
            holidays++;
        }
    }
    return holidays;
}

export function checkEDt(value) {
    //date has to be in future and can not be holiday or weekend
    const today = new Date();    
    var dt = new Date(value);

    // Check if the date is in the future
    if (dt <= today) {
        return "Enrollment Date has to be in future";
    }
    const dayOfWeek = dt.getDay();
    // console.log("DOW",dayOfWeek);
    if (dayOfWeek === 6 || dayOfWeek === 5) {
        return "Enrollment cannot start on weekend";
    }
    // console.log("DT",convertDateFormat(value));
    if (isHoliday(convertDateFormat(value))) {
        return "Enrollment Date cannot be a Holiday";
    }

}

export function convertCustomTimestamp(rec) {
    // Convert to string
    const dt = (rec.DT).toString();
    const parts = (rec.id).split(":");

    // Extract components
    const year = dt.slice(0, 4);
    const month = dt.slice(4, 6);
    const day = dt.slice(6, 8);
    /*const hours = parseInt(tsStr.substring(8, 10), 10);
    const minutes = parseInt(tsStr.substring(10, 12), 10);
    const seconds = parseInt(tsStr.substring(12, 14), 10);
    const milliseconds = parseInt(tsStr.substring(14, 17), 10); // First 3 digits after second*/

    // Create Date object
    // return new Date(year, month, day, hours, minutes, seconds, milliseconds);
    return `${year}-${month}-${day} ${parts[1].slice(0,4)}`
}

export function ClassroomFilter(props) {
    const { permissions } = usePermissions();
    // console.log("class filer",permissions)
    if (permissions !== undefined) {
        //split classrooms using , 
        // console.log(permissions.classroom.split(","))
        const ch = permissions.classroom.split(",").map(item => ({
            id: item,
            name: item
        }));
        //   console.log(ch) 
        return <SelectInput alwaysOn label="Classroom" source="Classroom" allowEmpty={false} choices={ch} />;

    } else {
        return;
    }
};